import { useAppSelector } from '@hooks/useRedux';
import { selectCurrentUser } from '@store/auth/authSelectors';
import React, { useEffect, useMemo, useState } from 'react';
import { SyncStatusChip } from '../common';
import { AppVersionWrapper } from '../nav/AppVersionWrapper';
import { UserActionsMenu } from '../nav/UserActionsMenu';

export const SalesNavbar: React.FC = () => {
  const currentUser = useAppSelector(selectCurrentUser);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const outletDayOpenDate = useMemo(() => {
    if (!currentUser?.outlet?.day_open) return null;
    const parsedDate = new Date(currentUser.outlet.day_open);
    if (Number.isNaN(parsedDate.getTime())) return null;
    return parsedDate;
  }, [currentUser?.outlet?.day_open]);

  const formattedDate = useMemo(() => {
    const sourceDate = outletDayOpenDate || currentTime;
    return sourceDate.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  }, [currentTime, outletDayOpenDate]);

  const outletName = useMemo(() => {
    return currentUser?.outlet?.name || 'Outlet';
  }, [currentUser?.outlet?.name]);

  return (
    <header className="flex h-14 flex-shrink-0 items-center justify-between border-b border-gray-200 bg-white px-4 text-black">
      <div className="flex min-w-0 items-center gap-3">
        <AppVersionWrapper />

        <span className="min-w-0 truncate border-l border-gray-300 pl-3 text-sm text-black">
          {formattedDate} | {outletName}
        </span>
      </div>

      <div className="flex items-center gap-3">
        <SyncStatusChip />
        <UserActionsMenu />
      </div>
    </header>
  );
};
